// 必須在 './router' 之前載入：createWebHistory 在建立當下即讀取（含 hash 的）location，
// 所以 OAuth 的 #access_token 要在 router 模組執行前先撿走並清掉，否則會被當 route.hash 留在網址列。
import { getToken, setToken } from './api/client'
import { takeFragmentToken } from './lib/loginFragment'

document.documentElement.dataset.theme =
  localStorage.getItem('ipo_theme') === 'dark' ? 'dark' : 'light'

// 批185（FE-07）：只收本分頁剛發起的登入帶回來的 token（nonce 比對，見 `lib/loginFragment.ts`）；
// 不收的也一樣從網址列清掉。
const _frag = takeFragmentToken(location.hash, 'access_token', { hasToken: !!getToken() })
if (_frag.present) {
  if (_frag.token) setToken(_frag.token)
  history.replaceState(null, '', location.pathname + location.search)
}
